export const pluckProperty = <T, K extends keyof T>(list: T[], propName: K): T[K][] => {
  return list?.map(item => item[propName]);
};
